/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	"use strict";
	/*globals Tc, doT, SCS */
	/*jshint smarttabs:true */
	/**
	 * CaseSelection module implementation.
	 *
	 * @author Zeljko Curcic
	 * @namespace Tc.Module
	 * @class CaseSelection
	 * @extends Tc.Module
	 */
	Tc.Module.CaseSelection = Tc.Module.extend({

		caseSelected: false,
		lastSelectedRadio: null,
		nextStepButton: null,

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			var mod = this,
				$radios = mod.$ctx.find('input[type=radio]');

			mod.nextStepButton = $('.multipage-wizard-step .multipage-forward-button');
			mod.nextStepButton.attr('href', mod.$ctx.data("default-url"));


			// save the initially checked radio
			mod.lastSelectedRadio = $radios.filter(':checked');

			$radios.on('change', function () {
				mod.changeCase($(this));
			});

			mod.nextStepButton.on('click', function () {
				mod.caseSelected = true;
			});

			callback();
		},

		changeCase: function (selectedRadio) {
			var mod = this,
				changeAllowed = true;

			// check if case has already been selected by the user before
			if (mod.caseSelected) {
				changeAllowed = confirm('If you change this, all the form data will be erased!');
			}

			if (changeAllowed) {
				mod.lastSelectedRadio = selectedRadio;

				// set the URL of the "next step"-button of the wizard to the target-URL of the selected case
				mod.nextStepButton.attr('href', selectedRadio.val());

				// trigger the wizard to delete all following steps
				mod.fire('clearWizardSteps', { stepContainer: mod.$ctx }, ['wizard']);

				// prevent further questions until the user clicked the "next"-button again
				mod.caseSelected = false;
			} else {
				// reset the radio to its last selection
				mod.lastSelectedRadio.focus().prop('checked', true);
			}
		}

	});
})(Tc.$);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/newrepair/Tc.Module.CaseSelection.js
// module id = 199
// module chunks = 0